export default {
  getScreenId(state) {
    return state.screen_id
  }
}
